import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { call, countryArr, QR } from "../../assets/img";
import { ICON_FILTER, URLS } from "../../Services/Constant";
import { get, post, put } from "../../Services/ApiHandler";
import "react-international-phone/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import Loader from "../../Component/Loader";
import countryData from "../../Services/CountryData.json";
import useStoreKv from "../redux/store/useStorekv";
import { Toast } from "../../Component/Toast";
import CustomScroll from "../../Component/CustomScroll";
import SubmitButton from "../../Component/SubmitButton";
import CommonPopup from "../../Component/CommonPopup";
import CommonReasonPopup from "../../Component/CommonReasonPopup";
import { MaskIcon } from "../../Component/MaskIcon";
import Cropper from "cropperjs";
import { PRIMARY_COLOR, PRIMARY_COLOR_RGB } from "../../Services/Colors";
import "cropperjs/dist/cropper.css";

const inputStyle = {
  width: "100%",
  height: 46,
  borderRadius: 8,
  border: `1.5px solid ${PRIMARY_COLOR}`,
  padding: "0 12px",
  fontSize: 14,
  background: "#F0EDE6",
  color: "#1B1B1B",
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "inherit",
};

const labelStyle = {
  fontSize: 13,
  fontWeight: 600,
  color: PRIMARY_COLOR,
  marginBottom: 5,
  display: "block",
};

/* ─────────────────────────────────────────
   UPDATE BANK DATA POPUP
───────────────────────────────────────── */
const UpdateBankPopup = ({ open, onClose, clientId, existing, onSuccess }) => {
  const [bankForm, setBankForm] = useState({
    acc_no: "",
    ifsc_code: "",
    acc_holder: "",
    upi_id: "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setBankForm({
        acc_no: existing?.anountno || "",
        ifsc_code: existing?.ifsc || "",
        acc_holder: existing?.accountholder || "",
        upi_id: existing?.upi || "",
      });
    }
  }, [open, existing]);

  const handleSave = async () => {
    if (!bankForm.acc_no.trim()) return Toast("Please enter your Account Number");
    if (!/^\d{9,18}$/.test(bankForm.acc_no)) return Toast("Account Number should be between 9 to 18 digits");
    if (!bankForm.ifsc_code.trim()) return Toast("Please enter IFSC Code");
    if (!bankForm.acc_holder.trim()) return Toast("Please enter Account Holder Name");
    if (!/^[A-Za-z ]+$/.test(bankForm.acc_holder)) return Toast("Account Holder Name should contain only alphabets");
    if (!bankForm.upi_id.trim()) return Toast("Please enter your UPI ID");

    const isExisting = !!existing?.anountno;
    const endpoint = isExisting
      ? `clients/wallet/bank-details/update`
      : `clients/wallet/bank-details`;

    const payload = {
      ...bankForm,
      client_id: clientId,
    };

    try {
      setSaving(true);
      const res = await post(endpoint, payload);
      if (res?.status === "success") {
        Toast("Bank details updated");
        onSuccess();
        onClose();
      } else {
        Toast(res?.message || "Failed to update");
      }
    } catch (err) {
      console.error("Error updating bank:", err);
      Toast("Failed to update bank details");
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 10000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: "#F0EDE6", borderRadius: 14, width: "100%", maxWidth: 460, maxHeight: "90vh", display: "flex", flexDirection: "column", boxShadow: `0 8px 32px rgba(${PRIMARY_COLOR_RGB.join(",")},0.18)`, overflow: "hidden" }}
      >
        <div style={{ background: PRIMARY_COLOR, padding: "14px 18px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
          <span style={{ color: "#fff", fontWeight: 700, fontSize: 17 }}>Update Bank Details</span>
          <button onClick={onClose} style={{ background: "transparent", border: "none", color: "#fff", fontSize: 22, cursor: "pointer", lineHeight: 1, padding: "0 2px" }}>×</button>
        </div>

        <div style={{ overflowY: "auto", flex: 1, padding: "18px 18px 8px", display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={labelStyle}>Account Number</label>
            <input
              style={inputStyle} name="acc_no" value={bankForm.acc_no}
              onChange={(e) => { const value = e.target.value.replace(/\D/g, "").slice(0, 16); setBankForm((prev) => ({ ...prev, acc_no: value })); }}
              placeholder="Enter account number" type="text" inputMode="numeric"
            />
          </div>
          <div>
            <label style={labelStyle}>IFSC Code</label>
            <input
              style={inputStyle} name="ifsc_code" value={bankForm.ifsc_code}
              onChange={(e) => { const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 11); setBankForm((prev) => ({ ...prev, ifsc_code: value })); }}
              placeholder="Enter IFSC code" type="text" maxLength={11}
            />
          </div>
          <div>
            <label style={labelStyle}>Account Holder Name</label>
            <input
              style={inputStyle} name="acc_holder" value={bankForm.acc_holder}
              onChange={(e) => { const value = e.target.value.replace(/[^A-Za-z ]/g, "").slice(0, 60); setBankForm((prev) => ({ ...prev, acc_holder: value })); }}
              placeholder="Enter account holder name" type="text"
            />
          </div>
          <div>
            <label style={labelStyle}>UPI ID</label>
            <input
              style={inputStyle} name="upi_id" value={bankForm.upi_id}
              onChange={(e) => { const value = e.target.value.slice(0, 30); setBankForm((prev) => ({ ...prev, upi_id: value })); }}
              placeholder="Enter UPI ID" type="text"
            />
          </div>
        </div>

        <div style={{ padding: "12px 18px 18px", display: "flex", gap: 10, flexShrink: 0 }}>
          <button onClick={onClose} style={{ flex: 1, height: 44, borderRadius: 8, border: `1.5px solid ${PRIMARY_COLOR}`, background: "transparent", color: PRIMARY_COLOR, fontWeight: 600, cursor: "pointer", fontSize: 14 }}>Cancel</button>
          <button
            onClick={handleSave} disabled={saving}
            style={{ flex: 1, height: 44, borderRadius: 8, border: "none", background: saving ? "#7ea1b8cc" : PRIMARY_COLOR, color: "#fff", fontWeight: 700, cursor: saving ? "not-allowed" : "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}
          >
            {saving ? <><span className="spinner-border spinner-border-sm" role="status" style={{ color: "#fff", width: 14, height: 14 }} />Saving…</> : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────── */
const ClientReport = () => {
  const { kv, set } = useStoreKv();
  const ClientView = kv.clientview || [];
  const location = useLocation();
  const type = location?.state?.type;
  const data = location?.state?.data;
  const localData = data?.client_id === ClientView?.clientID;
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [popup, setPopup] = useState(false);
  const [Remove, setRemove] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  const [isValidForm, setIsValidForm] = useState(false);
  const [isValidForm2, setIsValidForm2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [Addpopup, setAdd] = useState(false);
  const [UnblockUser, setUnblock] = useState(false);
  const [qrImage, setQrImage] = useState(null);
  const [load, setLoad] = useState(false);
  const [load2, setLoad2] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(countryData.find((c) => c.iso === "IN") || countryData[0]);
  const [isLoading, setIsLoading] = useState(false);
  const [updateUser, setUpdateUser] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupImage, setShowPopupImage] = useState(null);
  const [resetData, setResetData] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(null);
  const [updateBankOpen, setUpdateBankOpen] = useState(false);

  // ── Cropper states ──
  const [cropperModal, setCropperModal] = useState(false);
  const [cropperImage, setCropperImage] = useState(null);
  const [cropperInstance, setCropperInstance] = useState(null);
  const [qrCheck, setQrCheck] = useState(false);
  const cropperImageRef = useRef(null);
  const fileInputRef = useRef(null);

  const maxLength = selectedCountry?.maxLength;
  const [formData, setFormData] = useState(
    localData ? ClientView : { client: "", Clientname: "", mobile: "", Wallet: "", history: "", empty: "", anountno: "", ifsc: "", upi: "", clientID: "", block_reason: "", status: "" }
  );

  const getList = async () => {
    const postID = data?.client_id;
    if (!postID) return;
    try {
      if (!kv.clientview || kv.clientview.length === 0) setLoading(true);
      const res = await get(`${URLS.CLIENT}/${postID}`);
      if (res?.status === "success") {
        if (res?.data?.bank_details?.acc_no) setIsValidForm(true);
        if (res?.data?.bank_details?.qrcode) setIsValidForm2(true);
        const mapped = {
          clientID: res?.data?.client_id,
          Clientname: res?.data?.name,
          mobile: res?.data?.mobile,
          Wallet: res?.data?.wallet_amount,
          history: res?.data?.team_size,
          status: res?.data?.status,
          anountno: res?.data?.bank_details?.acc_no,
          ifsc: res?.data?.bank_details?.ifsc_code,
          upi: res?.data?.bank_details?.upi_id,
          accountholder: res?.data?.bank_details?.acc_holder,
        };
        setFormData(mapped);
        set("clientview", mapped);
        setQrImage(res?.data?.bank_details?.qrcode);
      } else {
        Toast(res?.message || "No data found");
        set("clientview", {});
      }
    } catch (err) {
      console.error("Error fetching role list:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (type === "edit") getList();
  }, [data?.client_id, type]);

  // ── Cropper useEffect ──
  useEffect(() => {
    if (cropperModal && cropperImageRef.current && cropperImage) {
      if (cropperInstance) cropperInstance.destroy();
      const cropper = new Cropper(cropperImageRef.current, {
        aspectRatio: 1,
        viewMode: 1,
        autoCropArea: 1,
        responsive: true,
        guides: true,
        center: true,
        cropBoxMovable: true,
        cropBoxResizable: true,
        minCropBoxWidth: 100,
        minCropBoxHeight: 100,
      });
      setCropperInstance(cropper);
    }
    return () => {
      if (cropperInstance) { cropperInstance.destroy(); setCropperInstance(null); }
    };
  }, [cropperModal, cropperImage]);

  // ── Cropper handlers ──
  const handleQrFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return Toast("File size should be less than 5MB");
    if (!file.type.match("image.*")) return Toast("Please select an image file");
    const reader = new FileReader();
    reader.onload = (event) => { setCropperImage(event.target.result); setCropperModal(true); };
    reader.readAsDataURL(file);
  };

  const handleCrop = () => {
    if (!cropperInstance) return;
    const croppedCanvas = cropperInstance.getCroppedCanvas({ width: 300, height: 300, fillColor: "#fff", imageSmoothingEnabled: true, imageSmoothingQuality: "high" });
    croppedCanvas?.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], `qr_${Date.now()}.png`, { type: "image/png" });
        setQrImage(file);
        setQrCheck(true);
        setCropperModal(false);
        setCropperImage(null);
        if (cropperInstance) { cropperInstance.destroy(); setCropperInstance(null); }
        Toast("Image cropped successfully!");
      }
    }, "image/png", 0.95);
  };

  const handleCancelCrop = () => {
    setCropperModal(false);
    setCropperImage(null);
    if (cropperInstance) { cropperInstance.destroy(); setCropperInstance(null); }
    if (fileInputRef.current) fileInputRef.current.value = "";
    Toast("Cropping cancelled");
  };

  const handleUpdateClientQR = async () => {
    try {
      setLoad(true);
      const form = new FormData();
      if (qrImage instanceof File) form.append("qrcode", qrImage);
      form.append("client_id",  formData.clientID )
      const res = await post(`/clients/wallet/qrcode/update`, form);
      if (res?.status === "success") {
        Toast("QR Code updated successfully!");
        setQrCheck(false);
        getList();
      }
    } catch (err) {
      console.error("QR Update Error:", err);
    } finally {
      setLoad(false);
    }
  };

  const handleChange = (e) => {
    if (!e || !e.target) return;
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCountrySelect = (country) => {
    setFormData((prev) => ({ ...prev, mobile: "" }));
    setSelectedCountry(country);
    setCountryCode(country.code);
    setDropdownOpen(false);
  };

  const validate = () => {
    let newErrors = {};
    if (!formData?.Clientname) newErrors.Name = "Name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    const cleanMobile = formData.mobile.replace(countryCode, "").replace(/[^\d]/g, "");
    const finalData = { name: formData?.Clientname, mobile: cleanMobile, country_code: countryCode };
    try {
      setIsLoading(true);
      const res = await put(`${URLS.CLIENT}/${data?.client_id}`, finalData);
      if (res?.status === "success") setUpdateUser(false);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setIsLoading(false);
      setUpdateUser(false);
    }
  };

  const handleDeleteBank = async () => {
    const posts = deleteStatus ? "bank-details/delete-qr" : "bank-details/delete";
    try {
      if (deleteStatus) setLoad(true); else setLoad2(true);
      const res = await post(`${URLS.CLIENT}/${data?.client_id}/${posts}`);
      if (res?.status === "success") {
        setFormData((prev) => ({ ...prev, anountno: "", ifsc: "", upi: "", accountholder: "" }));
        setIsValidForm(false);
        setResetData(false);
        getList();
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      if (deleteStatus) setLoad(false); else setLoad2(false);
      setResetData(false);
    }
  };

  const handleBlock = async (status) => {
    const payload = { block_reason: formData?.block_reason };
    try {
      setLoader(true);
      const changeStatus = status === "Blocked" ? "block" : "unblock";
      const res = await post(`${URLS.CLIENT}/${data?.client_id}/${changeStatus}`, payload);
      if (res?.status === "success") {
        if (status === "Blocked") setPopup(false); else setUnblock(false);
        getList();
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoader(false);
    }
  };

  const handleAddAmount = async (type) => {
    const posts = { client_id: formData?.clientID, amount: formData.empty, type };
    try {
      setLoad(true);
      const res = await post(`${URLS.CLIENTAMOUNTADD}`, posts);
      if (res?.status === "success") {
        setAdd(false); setRemove(false);
        setFormData((prev) => ({ ...prev, empty: "" }));
        getList();
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoad(false);
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, "");
    if (value.length <= maxLength) {
      setFormData((prev) => ({ ...prev, mobile: value }));
      setErrors((prev) => ({ ...prev, mobile: "" }));
    }
  };

  return (
    <div className="dashRightView">
      <CustomScroll>
        <div style={{ paddingTop: 0 }} className="container_overalls col-md-5">

          {/* ── Notes Button — navigates to separate page ── */}
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 4, marginTop: 12 }}>
            <button
              onClick={() =>
                navigate("/client-notes", {
                  state: {
                    clientId: formData?.clientID || data?.client_id,
                    clientName: formData?.Clientname,
                  },
                })
              }
              style={{ display: "inline-flex", alignItems: "center", gap: 6, background: PRIMARY_COLOR, color: "#fff", border: "none", borderRadius: 8, padding: "7px 16px", fontWeight: 700, fontSize: 13, cursor: "pointer", boxShadow: `0 2px 8px rgba(${PRIMARY_COLOR_RGB.join(",")},0.22)`, letterSpacing: 0.2 }}
            >
              <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="2" width="14" height="16" rx="2" stroke="#fff" strokeWidth="1.6" />
                <path d="M7 7h6M7 10h6M7 13h4" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
              </svg>
              Notes
            </button>
          </div>

          <div className="col-md-5 my-3">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Client ID</label>
            <input className="input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20 placholdercolorchanges2" name="clientID" style={{ color: "#575757" }} value={formData.clientID} onChange={handleChange} type="text" placeholder="Client ID" disabled />
          </div>

          <div className="col-md-5 my-3">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Client Name</label>
            <input className="placholdercolorchanges2 input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20" name="Clientname" value={formData.Clientname} onChange={handleChange} type="text" placeholder="Enter Client Name" />
            {errors.Clientname && <p className="err">{errors.Clientname}</p>}
          </div>

          <div className="form-group text-start my-3">
            <div className="form-group col-md-5 text-start">
              <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Mobile Number</label>
              <div className="login-input mt-1" style={{ height: 50, background: "#F0EDE6", display: "flex", alignItems: "center", borderRadius: 8, position: "relative" }}>
                <button type="button" onClick={() => setDropdownOpen(!dropdownOpen)} style={{ backgroundColor: "#6E6E6E", border: `1px solid ${PRIMARY_COLOR}`, color: "#ffffff", fontSize: 16, width: 60, height: 50, display: "flex", alignItems: "center", justifyContent: "center", gap: 4, cursor: "pointer", borderRadius: "8px 0 0 8px", position: "relative", padding: "0 34px" }}>
                  <img src={countryArr} alt="country dropdown arrow" style={{ width: 15, height: 9 }} />
                  {selectedCountry.code}
                </button>
                <input type="number" placeholder="Mobile Number" value={formData?.mobile} onChange={handleMobileChange} className="placholdercolorchanges2" style={{ flex: 1, border: "none", outline: "none", backgroundColor: "transparent", fontSize: 16, color: "#1B1B1B", padding: "0 10px", height: 50 }} />
                <MaskIcon src={call} alt="call icon" style={{ marginRight: 12, width: 20, top: 1, position: "relative" }} />
                {dropdownOpen && (
                  <div style={{ position: "absolute", top: 52, left: 0, right: 0, backgroundColor: "#ffffff", border: "1px solid rgb(0 71 67 / 40%)", borderRadius: 8, maxHeight: 200, overflowY: "auto", zIndex: 1000 }}>
                    {countryData.map((country) => (
                      <div key={country.iso} onClick={() => handleCountrySelect(country)} style={{ padding: "10px", cursor: "pointer", borderBottom: "1px solid rgb(0 71 67 / 40%)", backgroundColor: selectedCountry.iso === country.iso ? "#ffffff" : "#F0EDE6" }}>
                        {country.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>
            <div className="my-3">
              <SubmitButton onClick={() => setUpdateUser(true)} title="Update User" width={true} disabled={loading} isFormValid={loading} loading={loading} />
            </div>
          </div>

          <div className="form-group col-md-5 text-start my-3">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Wallet Balance</label>
            <div className="login-input2 mt-1">
              <input className="placholdercolorchanges2 f2 fs-xs-16 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20" name="Wallet" value={formData.Wallet} onChange={handleChange} type="text" placeholder="Wallet Balance" disabled />
              <p onClick={() => { if (formData?.clientID) navigate("/wallet-history", { state: { clientId: formData.clientID } }); }} className="f3 fs-xs-15 fs-sm-12 fs-md-14 sec fs-lg-15 fs-xl-16 fs-xxl-18 cursor-pointer">View History</p>
            </div>
          </div>

          <div className="form-group col-md-5 text-start my-3">
            <div className="login-input mt-3">
              <input className="placholdercolorchanges2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20" name="empty" value={formData.empty} onChange={handleChange} type="number" placeholder="Enter Amount" onInput={(e) => { if (e.target.value.length > 11) e.target.value = e.target.value.slice(0, 11); }} />
            </div>
          </div>

          <div className="removeAddBtn my-3 d-flex ac-jb">
            <button disabled={!formData.empty} onClick={() => setRemove(true)} className="remove-button f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19">Remove</button>
            <button onClick={() => setAdd(true)} className="Add-Button f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 sec" disabled={!formData.empty} style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", minHeight: 48, backgroundColor: !formData.empty ? "#7ea1b8cc" : PRIMARY_COLOR, border: !formData.empty ? "1px solid #7ea1b8cc" : `1px solid ${PRIMARY_COLOR}` }}>
              Add
            </button>
          </div>

          <div className="form-group col-md-5 text-start my-3">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Team Size</label>
            <div className="login-input2 mt-1">
              <input className="placholdercolorchanges2 f2 fs-xs-16 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20" name="userName" value={formData.history} onChange={handleChange} type="text" placeholder="0" disabled />
              <p onClick={() => { if (formData?.clientID) navigate("/team-size", { state: { clientId: formData.clientID } }); }} className="f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-16 sec fs-xxl-18 cursor-pointer">View Team</p>
            </div>
          </div>

          <div className="col-md-5 my-3">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Account Number</label>
            <input className="placholdercolorchanges2 input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20" name="anountno" style={{ color: "#5e5e5e" }} value={formData.anountno} onChange={handleChange} type="text" placeholder="Account number is not added" disabled />
          </div>
          <div className="col-md-5 my-3">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">IFSC Code</label>
            <input className="placholdercolorchanges2 input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20" name="ifsc" value={formData.ifsc} style={{ color: "#5e5e5e" }} onChange={handleChange} type="text" placeholder="IFSC code is not added" disabled />
          </div>
          <div className="col-md-5 my-3">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Account Holder Name</label>
            <input className="placholdercolorchanges2 input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20" name="accountholder" value={formData.accountholder} onChange={handleChange} style={{ color: "#5e5e5e" }} type="text" placeholder="Account holder name is not added" disabled />
          </div>
          <div className="col-md-5 my-3">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">UPI ID</label>
            <input className="placholdercolorchanges2 input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20" name="userName" value={formData.upi} onChange={handleChange} style={{ color: "#5e5e5e" }} type="text" placeholder="UPI ID is not added" disabled />
          </div>

          <div className="my-3">
            <SubmitButton onClick={() => setUpdateBankOpen(true)} title="Update Bank Data" width={true} disabled={false} isFormValid={false} />
          </div>

          <div className="my-3">
            <SubmitButton onClick={() => { setDeleteStatus(false); setResetData(true); }} title="Reset Bank Data" disabled={!isValidForm} isFormValid={!isValidForm} loading={load2} width={true} />
          </div>

          {/* ── QR Upload ── */}
          <input id="clientQrUpload" ref={fileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleQrFileChange} />

          <div className="QR d-flex ac-jc adjwidthqr" style={{ cursor: "pointer", position: "relative" }}>
            <div style={{ position: "relative" }} className="mt-2 text-center QRCode_container">
              <label htmlFor="clientQrUpload" style={{ cursor: "pointer" }}>
                {qrImage ? (
                  <img src={qrImage instanceof File ? URL.createObjectURL(qrImage) : qrImage} alt="QR Preview" style={{ width: "150px", height: "150px", borderRadius: "10px", objectFit: "contain" }} />
                ) : (
                  <>
                    <img src={QR} alt="QR Placeholder" style={{ width: "150px", height: "150px", borderRadius: "10px", objectFit: "contain", border: "1.8px dashed #a7a3a3" }} />
                    <span style={{ position: "absolute", top: 50, left: 0, right: 0, color: "gray", fontWeight: 600, textAlign: "center" }}>User <br /> QR Code</span>
                  </>
                )}
              </label>
            </div>
          </div>

          <div className="my-3">
            <SubmitButton onClick={handleUpdateClientQR} title="Update QR Code" disabled={!qrCheck || load} isFormValid={!qrCheck || load} loading={load} width={true} />
          </div>

          <div className="my-3">
            <SubmitButton onClick={() => { setDeleteStatus(true); setResetData(true); }} title="Reset QR Code" disabled={!isValidForm2} isFormValid={!isValidForm2} loading={load} width={true} />
          </div>

          <div style={{ marginTop: 16, marginBottom: 80, display: "flex", flexDirection: "column" }}>
            <SubmitButton onClick={() => setPopup(true)} title="Block User" disabled={formData?.status === 2 || formData?.status === 3} isFormValid={formData?.status === 2 || formData?.status === 3} loading={loader} width={true} />
            <SubmitButton onClick={() => setUnblock(true)} title="Unblock User" style={{ marginTop: 15 }} disabled={formData?.status === 1 || formData?.status === 0} isFormValid={formData?.status === 1 || formData?.status === 0} loading={loader} width={true} />
          </div>
        </div>
      </CustomScroll>

      <UpdateBankPopup open={updateBankOpen} onClose={() => setUpdateBankOpen(false)} clientId={formData?.clientID || data?.client_id} existing={formData} onSuccess={getList} />
      <CommonReasonPopup open={popup} onClose={() => setPopup(false)} value={formData?.block_reason} onChange={(value) => setFormData((prev) => ({ ...prev, block_reason: value }))} onSubmit={() => handleBlock("Blocked")} loading={loader} buttonText="Block User" />
      <CommonPopup isOpen={Remove} message="Are you sure, you want to Remove amount from this Client Wallet !" onClose={() => setRemove(false)} onConfirm={() => handleAddAmount("debit")} loading={load} confirmText="Confirm" />
      {loading && <Loader />}
      <CommonPopup isOpen={Addpopup} message="Are you sure, you want to Add amount to this Client Wallet !" onClose={() => setAdd(false)} onConfirm={() => handleAddAmount("add")} loading={load} confirmText="Confirm" />
      <CommonPopup isOpen={UnblockUser} message="Are you sure, you want to unblock this Client ?" onClose={() => setUnblock(false)} onConfirm={handleBlock} loading={loader} confirmText="Confirm" />
      <CommonPopup isOpen={updateUser} message="Are you sure, you want to Update ?" onClose={() => setUpdateUser(false)} onConfirm={handleSubmit} loading={isLoading} />
      <CommonPopup isOpen={resetData} message={`Are you sure, you want to Delete ${deleteStatus ? "QR Code" : "Bank Data"} ?`} onClose={() => setResetData(false)} onConfirm={handleDeleteBank} loading={deleteStatus ? load : load2} />

      {showPopup && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.8)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }} onClick={() => setShowPopup(false)}>
          <div style={{ position: "relative", maxWidth: "90%", maxHeight: "90%" }} onClick={(e) => e.stopPropagation()}>
            {showPopupImage ? <img src={showPopupImage} alt="QR Code Popup" style={{ width: "100%", height: "auto", borderRadius: 10, boxShadow: "0 0 15px rgba(0,0,0,0.4)" }} /> : <span style={{ color: "white" }} className="f3">QR Not Available</span>}
          </div>
        </div>
      )}

      {/* ── Cropper Modal ── */}
      {cropperModal && (
        <div className="img-popup-design" style={{ zIndex: 9999 }}>
          <div className="img-popup" style={{ maxWidth: "90%", width: "800px", maxHeight: "90vh" }}>
            <h4 className="f3 primary mb-3">Crop QR Code</h4>
            <p className="text-muted mb-3">Adjust the crop area, then click "Crop & Save"</p>
            <div style={{ width: "100%", height: "400px", marginBottom: "20px", backgroundColor: "#f5f5f5" }}>
              <img ref={cropperImageRef} src={cropperImage} alt="Crop preview" style={{ maxWidth: "100%", maxHeight: "100%", display: "block" }} crossOrigin="anonymous" />
            </div>
            <div className="d-flex justify-content-center gap-3 mt-3">
              <button onClick={handleCancelCrop} className="no-btn f3" style={{ minWidth: "120px", padding: "10px 20px" }}>Cancel</button>
              <button onClick={handleCrop} className="yes-btn f3" style={{ minWidth: "120px", padding: "10px 20px" }}>Crop & Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientReport;